export default __webpack_public_path__ + "static/media/one-concept.b8e5133f.png";